import { Component, OnInit } from '@angular/core';
import { MessageInfoService } from 'src/app/_services/messageInfo.service copy';

@Component({
  selector: 'app-sent-message-list-all',
  templateUrl: './sent-message-list-all.component.html',
  styleUrls: ['./sent-message-list-all.component.css']
})
export class SentMessageListAllComponent implements OnInit {
  sentMessageList: any[] = [];
sentMessagesCount: number = 0;
  constructor(private messageInfoService:MessageInfoService) { }

  ngOnInit(): void {
    this.messageInfoService.getAll().subscribe(
      {
        next:(data)=>{
          this.sentMessageList=data.rs.data
          this.sentMessagesCount=this.sentMessageList.length
        },error:(err)=>{
          console.error("error getAllSentMessages",err)
        }
      }
    )
  }

}
